export const updateIndex = (e, selectedFeatureIndex, view) => {
  let val = e as number; //.target.value as number
  let index = selectedFeatureIndex - 1;
  let numOfMoves = val - index;
  if (numOfMoves > 0) {
    while (numOfMoves > 0) {
      view.popup.next();
      numOfMoves = numOfMoves - 1;
    }
  } else if (numOfMoves < 0) {
    while (numOfMoves < 0) {
      view.popup.previous();
      numOfMoves = numOfMoves + 1;
    }
  }
};
export const getFieldsListFromString=(inputString)=>{
    let matches= inputString.match(/\{(.*?)\}/g);
    if (matches) {
      // Extract the content between curly braces and store in a variable
      const extractedContent = matches.map(match => match.slice(1, -1));
      
      return extractedContent;
    } else {
      // Return an empty array if no matches are found
      return [];
    }
  };

  export const zoomToFeature = (view) => {
    if (view.popup.selectedFeature.layer.geometryType === 'multipoint'){

      const selectlayer = view.popup.selectedFeature.layer
      let queryselect = selectlayer.createQuery();
      queryselect.returnGeometry = true;
      queryselect.outFields = ["*"];
      queryselect.spatialRelationship = "intersects"; 
      queryselect.where = "OBJECTID =" + view.popup.selectedFeature.attributes.OBJECTID;
      selectlayer.queryFeatures(queryselect)
      .then(function(results){
          if (results.features[0].geometry['points'].length > 1){
            view.goTo(results.features[0].geometry)
          } else {
            view.goTo({
              target: results.features[0].geometry,
              zoom: 15
            });
            
          }

        })   
    }
     else if (view.popup.selectedFeature.layer.geometryType === 'point'){
      view.goTo({
        target: view.popup.selectedFeature,
        zoom: 15
      });
      
    } 
    else  {
      view.goTo(view.popup.selectedFeature)
    }
  };